import getConstantValue from '@atlas/tool/box/slate/getConstantValue';
import { Editor, Transforms, Point, Text } from 'slate';

export default function withConstants(editor: Editor) {
    const { normalizeNode } = editor;

    const removeConstant = (anchor: Point, focus: Point) => {
        Transforms.unsetNodes(editor, 'constant', {
            match: Text.isText,
            at: { anchor, focus },
            split: true,
        });
    };

    editor.normalizeNode = (entry) => {
        const [node, path] = entry;

        if (Text.isText(node) && typeof node.constant === 'string') {
            const value = getConstantValue(node.constant);
            if (value !== node.text) {
                if (node.text.includes(value)) {
                    const index = node.text.indexOf(value);

                    if (index > 0) {
                        removeConstant({ offset: 0, path }, { offset: index, path });
                    }

                    if (index + value.length < node.text.length) {
                        removeConstant({ offset: index + value.length, path }, { offset: node.text.length, path });
                    }
                } else {
                    removeConstant({ path, offset: 0 }, { path, offset: node.text.length });
                }
            }
        }

        normalizeNode(entry);
    };

    return editor;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('withConstants', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
